import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';

const ELEMENT_DATA: any = [
  { name: 'Nikhil Yadav', password: 'xxxxxCC', address: 'chennai', email: 'nikhil.yaadav@gmail.com', alternate_email: 'nikhil.yaadav@gmail.com', contact_number: '+91-9826700492', alternate_number: '+91-9826700492', },
  { name: 'Nikhil Yadav', password: 'xxxxxCC', address: 'chennai', email: 'nikhil.yadav@gmail.com', alternate_email: 'nikhil.yaadav@gmail.com', contact_number: '+91-9826700492', alternate_number: '+91-9826700492', },
  { name: 'Nikhil Yadav', password: 'xxxxxCC', address: 'chennai', email: 'nikhil.yadav@gmail.com', alternate_email: 'nikhil.yaadav@gmail.com', contact_number: '+91-9826700492', alternate_number: '+91-9826700492', },
];
@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {


  constructor(public dialog: MatDialog, private toastr: ToastrService) { }
  displayedColumns: string[] = ['name', 'password', 'email', 'alternate_email', 'contact_number', 'alternate_number', 'address'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  public searchInput = new FormControl('');


  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
}
